import { Col, Row } from 'antd';
import React from 'react';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import SponsorOptionPageHeroText from '../../CommonComponents/SponsorOptionPageHeroText';
import IndustryHighlights from './IndustryHighlights';
import useLocalization from '../../../Localization';

const IndustryOutReachComponent = ({ industryData }) => {
  const { ApplicationString } = useLocalization();
  const IndustryComponentHTML = industryData?.industry;
  return (
    <React.Fragment>
      <Row gutter={[0, 30]} className='pbssMainContainerRow'>
        <Col span={24}>
          <SponsorOptionPageHeroText
            title={ApplicationString['industryOutreachComponent.title']}
            subTitle={ApplicationString['pbss.generalInformation.subtitle']}
          />
        </Col>
        <Col span={24}>
          <SectionLayout>
            <div dangerouslySetInnerHTML={{ __html: IndustryComponentHTML }}></div>
          </SectionLayout>
        </Col>
        <Col span={24}>
          <IndustryHighlights data={industryData} />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default IndustryOutReachComponent;
